import React, {
  Fragment,
} from 'react';
import { translate } from '../../Services/translation';

const GridViewNonPimItemContainer = (props) => {
    return (
        <Fragment>
            {
                props.nonPIMItems.length > 0 && (
                    <div className="product-wrap--outer">
                        <ul className="row product-list product-list__wrapp">
                            {props.nonPIMItems.map((item, subindex) =>
                                <Fragment key={'chassi-non-pim-fg' + subindex}>
                                    <li className="product-list__item columns small-12 small-plus medium-4 large-3">
                                        <figure className="product__figure">
                                        </figure>
                                        <article className="product__info">
                                            <a className="product__name--link">
                                                <h3 className="product__name">
                                                    {item.Description}
                                                    <svg><use href="/ui/images/sprites/brenderup.svg#right-arrow"></use></svg>
                                                </h3>
                                            </a>
                                            <div className="product__buy">
                                            <a className="button buy-button product__buy-button disabled">
                                                {translate('button.addtocart')}
                                            </a>
                                            </div>
                                        </article>
                                    </li>
                                </Fragment>
                            )}
                        </ul>

                    </div>
                  
  )}
  </Fragment>
    );
  };

export default GridViewNonPimItemContainer;
